/**
 * Shared Preview UI helpers: calendar locale registration + period display labels.
 * Raw API period tokens stay Slovak; only visible option text is translated.
 */

export const PREVIEW_PERIOD_RAW = ['Všetko', 'Za deň', 'Za mesiac', 'Za rok', 'Vlastné'];

export const PREVIEW_CALENDAR_DAY_CODES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const PREVIEW_CALENDAR_MONTH_CODES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function previewCalendarLocaleCode(locale) {
  if (!locale || locale === 'gb') return 'en';
  if (locale === 'en' || locale === 'de' || locale === 'sk') return locale;
  return 'sk';
}

export function buildPreviewPeriodOptionLabels(t) {
  const tr = typeof t === 'function' ? t : (k) => k;
  return {
    Všetko: tr('Common.Period.All'),
    'Za deň': tr('Common.Period.Day'),
    'Za mesiac': tr('Common.Period.Month'),
    'Za rok': tr('Common.Period.Year'),
    Vlastné: tr('Common.Period.Custom'),
  };
}

export function buildPreviewCalendarLocale(t) {
  const tr = typeof t === 'function' ? t : (k) => k;
  return {
    firstDayOfWeek: 1,
    showMonthAfterYear: false,
    dayNames: PREVIEW_CALENDAR_DAY_CODES.map((d) => tr(`Common.Day.${d}`)),
    dayNamesShort: PREVIEW_CALENDAR_DAY_CODES.map((d) => tr(`Common.DayShort.${d}`)),
    dayNamesMin: PREVIEW_CALENDAR_DAY_CODES.map((d) => tr(`Common.DayMin.${d}`)),
    monthNames: PREVIEW_CALENDAR_MONTH_CODES.map((m) => tr(`Common.Month.${m}`)),
    monthNamesShort: PREVIEW_CALENDAR_MONTH_CODES.map((m) => tr(`Common.MonthShort.${m}`)),
    today: tr('Common.Today'),
    clear: tr('Common.Clear'),
    chooseDate: tr('Common.ChooseDate'),
    chooseMonth: tr('Common.ChooseMonth'),
    chooseYear: tr('Common.ChooseYear'),
    prevMonth: tr('Common.PrevMonth'),
    nextMonth: tr('Common.NextMonth'),
    prevYear: tr('Common.PrevYear'),
    nextYear: tr('Common.NextYear'),
    weekHeader: tr('Common.WeekHeader'),
  };
}

/**
 * Register PrimeReact locale for Preview calendars. Returns the locale code to pass to <Calendar locale=...>.
 */
export function registerPreviewCalendarLocale(addLocale, locale, t) {
  const code = previewCalendarLocaleCode(locale);
  addLocale(code, buildPreviewCalendarLocale(t));
  return code;
}
